export function convertToMinCrossingInterval(timeString: string): string {
  // Use a Regular Expression to match the 'HH:MM:SS' format
  const regex = /^(\d{2}):(\d{2}):(\d{2})$/;
  const match = timeString.match(regex);

  if (match) {
    // If the timeString matches, return the 'HH:MM' part
    return `${match[1]}:${match[2]}`;
  } else {
    // If the timeString does not match, return '00:00' as a default or fallback
    return '00:00';
  }
}
